import {
	NoteTemplateCategory,
	NoteTemplateIcon,
	useArchiveNoteTemplateMutation,
	useCreateNoteTemplateCategoryMutation,
	useCreateNoteTemplateMutation,
	useNoteTemplateCategoriesQuery,
	useNoteTemplateQuery,
	useNoteTemplatesLazyQuery,
	useNoteTemplatesQuery,
	useRestoreNoteTemplateMutation,
	useUpdateNoteTemplateMutation,
} from '@treams/treams-network';

import { DetailsTableFormValueTypes } from '../../packages/kakapo-ui-kit/components/common/DetailsTableForm/DetailsTableFormValue';
import validator from '../../packages/kakapo-ui-services/factories/ValidatorFactory';
import SettingsEntity from '../generic/SettingsEntity';
import { FormData } from '../generic/types';

const NotesTemplatesSettings = () => {
	const formData: FormData<NoteTemplateCategory> = {
		subject: {
			singular: 'noteTemplate',
			plural: 'noteTemplates',
		},
		fields: [
			{
				name: 'title',
				value: [],
				type: DetailsTableFormValueTypes.Multilingual,
				validation: validator
					.array(
						validator.object({
							text: validator.string().min(1).max(256).required(),
						}),
					)
					.min(1),
			},
			{
				name: 'subtitle',
				value: [],
				type: DetailsTableFormValueTypes.Multilingual,
				validation: validator
					.array(
						validator.object({
							text: validator.string().min(0).max(256),
						}),
					)
					.optional(),
			},
			{
				name: 'icon',
				value: NoteTemplateIcon.View,
				type: DetailsTableFormValueTypes.Select,
				options: Object.keys(NoteTemplateIcon).map((key) => ({
					label: key,
					value: NoteTemplateIcon[key],
				})),
			},
			{
				name: 'iconColor',
				value: '',
				type: DetailsTableFormValueTypes.Text,
			},
			{
				name: 'description',
				value: [],
				type: DetailsTableFormValueTypes.MultilingualQuill,
			},
			{
				name: 'category',
				value: null,
				type: DetailsTableFormValueTypes.CreateSelect,
				fetchContent: useNoteTemplateCategoriesQuery,
				createContent: useCreateNoteTemplateCategoryMutation,
				validation: validator.string().required(),
			},
		],
		queryForAll: useNoteTemplatesQuery,
		lazyQueryForAll: useNoteTemplatesLazyQuery,
		queryForSingle: useNoteTemplateQuery,
		create: useCreateNoteTemplateMutation,
		update: useUpdateNoteTemplateMutation,
		archive: useArchiveNoteTemplateMutation,
		restore: useRestoreNoteTemplateMutation,
		variables: {
			global: false,
		},
	};

	return <SettingsEntity formData={formData} />;
};
export default NotesTemplatesSettings;
